"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSessionStorage = exports.setLocalStorage = exports.DOMStorage = void 0;
const dom_storage_1 = __importDefault(require("dom-storage"));
let localStorage;
let sessionStorage;
function DOMStorage() {
    if (typeof window === "object") {
        if (!localStorage)
            localStorage = window.localStorage;
        if (!sessionStorage)
            sessionStorage = window.sessionStorage;
        return { localStorage, sessionStorage };
    }
    if (!localStorage)
        localStorage = new dom_storage_1.default("./.localStorage.json");
    if (!sessionStorage)
        sessionStorage = new dom_storage_1.default(null);
    return { localStorage, sessionStorage };
}
exports.DOMStorage = DOMStorage;
function setLocalStorage(instance) {
    localStorage = instance;
}
exports.setLocalStorage = setLocalStorage;
function setSessionStorage(instance) {
    sessionStorage = instance;
}
exports.setSessionStorage = setSessionStorage;
